export const fieldRequiredMessage = {
  es: "Este campo es obligatorio.",
  en: "This field is required.",
};
export const addressNotSelectedMessage = {
  es: "Seleccioná una de las opciones del desplegable.",
  en: "Select one of the options from the dropdown.",
};
export const emailFormatMessage = {
  es: "El formato debe ser direccion@mail.com",
  en: "The format has to be address@email.com",
};
export const specialCharactersMessage = {
  es: "No debe contener caracteres especiales ni espacios.",
  en: "Cannot contain special characters or spaces",
};
export const lettersMessage = {
  es: "No debe contener números ni caracteres especiales.",
  en: "Cannot contain numbers or special characters",
};
export const alphanumericStringMessage = {
  es: "No debe contener caracteres especiales.",
  en: "Cannot contain special characters",
};
export const maxMessage = (max: number) => ({
  es: `Debe tener menos de ${max} caracteres.`,
  en: `Has to be at least ${max} characters long`,
});
export const smallerThanMessage = (value?: string | number) => ({
  es: value ? `Debe ser menor a ${value}.` : "El valor es demasiado chico.",
  en: value ? `Has to be smaller than ${value}.` : "The value is too small.",
});
export const largerThanMessage = (value?: string | number) => ({
  es: value ? `Debe ser mayor a ${value}.` : "El valor es demasiado chico.",
  en: value ? `Has to be larger than ${value}.` : "The value is too small.",
});
export const tokenMessage = {
  es: "Debe tener 7 caracteres.",
  en: "Has to be 7 characters long",
};
export const numberRequiredMessage = {
  es: "Deben ser solo números.",
  en: "Has to contain numbers only",
};
export const phoneNumberRequiredMessage = {
  es: "Deben ser entre 9 y 12 números.",
  en: "Has to be bewteen 9 and 12 digits long.",
};
export const internationalPhoneNumberMessage = {
  es: "Deben ser entre 9 y 15 números.",
  en: "Has to be between 9 and 15 digits long.",
};
export const cbuRequiredMessage = {
  es: "Deben ser 22 números.",
  en: "Has to be 22 digits",
};
export const dniRequiredMessage = {
  es: "Deben ser 7 u 8 números.",
  en: "Has to be 7 or 8 digits long",
};
export const tramitNumberRequiredMessage = {
  es: "Deben ser 11 números.",
  en: "Has to be 11 digits long.",
};
export const optionRequiredMessage = {
  es: "Debe seleccionar al menos una opción.",
  en: "Choose at least one option",
};
export const invalidDocumentFormatMessage = {
  es: "El formato del Documento es inválido",
  en: "Invalid document format.",
};
export const invalidCuitPrefixMessage = {
  es: "Debe comenzar con 20, 23, 24, 27, 30 o 33.",
  en: "Has to start with 20, 23, 24, 27, 30 or 33.",
};
export const invalidCuitPFPrefixMessage = {
  es: "Debe comenzar con 20, 23, 24 o 27.",
  en: "Has to start with 20, 23, 24 or 27",
};
export const invalidCuitPJPrefixMessage = {
  es: "Debe comenzar con 30 o 33.",
  en: "Has to start with 30 or 33.",
};
export const cuitRequiredMessage = {
  es: "Deben ser 11 números.",
  en: "Has to be 11 digits long.",
};

export const invalidCuitCheckDigitMessage = {
  es: "El CUIT/CUIL no es válido. Revisá los números.",
  en: "The CUIT/CUIL is not valid. Please check the digits.",
};
export const pastDateRequiredMessage = {
  es: "La fecha debe ser anterior a la actual.",
  en: "The date has to be in the past.",
};
export const futureDateRequiredMessage = {
  es: "La fecha debe ser posterior a la actual.",
  en: "The date has to be in the future.",
};

export const birthDateRequiredMaxMessage = {
  es: "La fecha debe ser anterior al día de hoy.",
  en: "The date cannot be in the future.",
};

export const birthDateRequiredMinMessage = {
  es: "La fecha debe ser posterior a 01/01/1900.",
  en: "The date cannot be too far in the past.",
};

export const minAgeMessage = (minAge: number) => ({
  es: `Tenés que ser mayor de ${minAge} años.`,
  en: `You must be at least ${minAge} years old.`,
});

export const dateFormatMessage = {
  es: "El formato debe ser DD/MM/AAAA",
  en: "The format has to be DD/MM/YYYY",
};

export const percentagesAddUpMessage = {
  es: "Los porcentajes deben sumar a 100",
  en: "Percentages have to add up to 100",
};

export const percentageRangeMessage = {
  es: "No debe superar el 100.",
  en: "Has to be less than 100.",
};

export const percentageGreaterThanZeroMessage = {
  es: "Debe ser mayor a 0.",
  en: "Has to be greater than 0.",
};

export const percentageDecimalsMessage = {
  es: "Ingresá hasta 2 decimales.",
  en: "At most 2 decimals.",
};

export const emailNotMatchMessage = {
  es: "Los emails no coinciden.",
  en: "The emails do not match.",
};
export const ssnRequiredMessage = {
  es: "Deben ser 9 dígitos.",
  en: "Has to be 9 digits long",
};

export const differentCuitMessage = {
  es: "Debe ser distinto al tuyo.",
  en: "Must be different from yours.",
};

export const duplicateHolderTaxIdMessage = {
  es: "No puede ser igual al de otro titular.",
  en: "It can't be the same as another holder's.",
};

export const duplicateCuitMessage = {
  es: "No se puede utilizar la misma identificación fiscal para más de un accionista",
  en: "The same tax ID cannot be used for more than one shareholder",
};

export const duplicateEmailMessage = (entity = "firmante") => ({
  es: `No se puede utilizar el mismo mail para más de un ${entity}.`,
  en: `The same email cannot be used for more than one ${entity}.`,
});

export const duplicateDniMessage = (entity: string) => ({
  es: `No se puede utilizar el mismo DNI para más de un ${entity}.`,
  en: `The same DNI cannot be used for more than one ${entity}.`,
});

export const fileNameSpecialCharactersMessage = ({
  es: `El nombre del archivo solo puede contener letras y números, sin espacios ni caracteres especiales.`,
    en: `The name of the file can only contain letters and numbers, no spaces or special characters.`,

})
